import { useEffect, useState } from "react";

import Box from '@mui/material/Box';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    Typography,
    Avatar,
} from "@mui/material";
import Drawer from '@mui/material/Drawer';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
// import axios from "axios";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

function HeaderDashboard(props) {

    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const navigate = useNavigate()

    useEffect(() => {
        const validarToken = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("../");
            }

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/hasPlan`, {
                headers: {
                    Authorization: token
                }
            })

            if (response.data.status === 400) {
                navigate("../Planos");
            }
        };
        validarToken();
    }, [navigate])

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 50) {
                setShowHeader(false);
            } else {
                setShowHeader(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    const [open, setOpen] = useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        navigate("../");
    }

    const menuItem = (
        icon,
        label,
        path,
        active = false
    ) => (
        <ListItem disablePadding sx={{ mb: 0.4 }}>
            <ListItemButton
                onClick={() => navigate(path)}
                sx={{
                    minHeight: 44,
                    px: 1.5,
                    borderRadius: "10px",

                    color: active ? "#0B243D" : "#64748B",

                    backgroundColor: active
                        ? "#FFC845"
                        : "transparent",

                    "&:hover": {
                        backgroundColor: active
                            ? "#FFC845"
                            : "#F5F7F9",
                    },

                    transition: "all 0.2s ease",
                }}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 38,
                        color: active
                            ? "#0B243D"
                            : "#64748B",
                    }}
                >
                    {icon}
                </ListItemIcon>

                <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                        fontSize: 13.5,
                        fontWeight: active ? 700 : 500,
                    }}
                />
            </ListItemButton>
        </ListItem>
    );

    const DrawerList = (
    <Box
        sx={{
            width: 270,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFFFFF",
        }}
        role="presentation"
    >

        {/* HEADER */}
        <Box
            sx={{
                px: 2.2,
                pt: 2.2,
                pb: 1.8,
            }}
        >
            <Typography
                sx={{
                    fontSize: 20,
                    fontWeight: 800,
                    color: "#0B243D",
                    letterSpacing: "-0.5px",
                }}
            >
                Clarea Vital
            </Typography>

            <Typography
                sx={{
                    mt: -0.2,
                    fontSize: 9,
                    fontWeight: 700,
                    letterSpacing: "1.5px",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                }}
            >
                Contabilidade
            </Typography>
        </Box>
        <Divider sx={{ mb: 1.2 }} />

        {/* MENU */}
        <Box
            sx={{
                px: 1.2,
                flex: 1,
                overflowY: "auto",
            }}
        >

            {/* PRINCIPAL */}
            <Typography
                sx={{
                    px: 1.2,
                    mb: 0.8,
                    fontSize: 10,
                    fontWeight: 700,
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                }}
            >
                Principal
            </Typography>

            <List disablePadding>

                {menuItem(
                    <DashboardOutlinedIcon fontSize="small" />,
                    "Dashboard",
                    "../Dashboard"
                )}

            </List>


            {/* FISCAL */}
            <Typography
                sx={{
                    px: 1.2,
                    mt: 2,
                    mb: 0.8,
                    fontSize: 10,
                    fontWeight: 700,
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                }}
            >
                Fiscal
            </Typography>

            <List disablePadding>

                {menuItem(
                    <ReceiptLongOutlinedIcon fontSize="small" />,
                    "Notas fiscais",
                    "../Dashboard/NotasFiscaisEmitidas"
                )}

                {menuItem(
                    <MedicalServicesOutlinedIcon fontSize="small" />,
                    "Serviços",
                    "../Dashboard/Servicos"
                )}

                {menuItem(
                    <DescriptionOutlinedIcon fontSize="small" />,
                    "Documentos",
                    "../Dashboard/Documentos"
                )}

            </List>


            {/* EMPRESA */}
            <Typography
                sx={{
                    px: 1.2,
                    mt: 2,
                    mb: 0.8,
                    fontSize: 10,
                    fontWeight: 700,
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                }}
            >
                Empresa
            </Typography>

            <List disablePadding>

                {menuItem(
                    <AssignmentOutlinedIcon fontSize="small" />,
                    "Ficha cadastral",
                    "../Dashboard/FichaCadastral"
                )}

                {menuItem(
                    <BusinessOutlinedIcon fontSize="small" />,
                    "Dados da empresa",
                    "../Dashboard/Empresa"
                )}

            </List>


            {/* FINANCEIRO */}
            <Typography
                sx={{
                    px: 1.2,
                    mt: 2,
                    mb: 0.8,
                    fontSize: 10,
                    fontWeight: 700,
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: "0.8px",
                }}
            >
                Financeiro
            </Typography>

            <List disablePadding>

                {menuItem(
                    <AccountBalanceWalletOutlinedIcon fontSize="small" />,
                    "Faturas",
                    "../Dashboard/Faturas/Pendentes"
                )}

                {menuItem(
                    <CreditCardOutlinedIcon fontSize="small" />,
                    "Meu plano",
                    "../Dashboard/Assinatura"
                )}

            </List>

        </Box>


        {/* RODAPÉ */}
        <Box
            sx={{
                px: 1.2,
                pb: 1.5,
                pt: 1,
            }}
        >

            <Divider sx={{ mb: 1 }} />

            <List disablePadding>

                {menuItem(
                    <PersonOutlineOutlinedIcon fontSize="small" />,
                    "Meu perfil",
                    "../Dashboard/Perfil"
                )}

                <ListItem disablePadding sx={{ mb: 0.4 }}>
                    <ListItemButton
                        onClick={() => {
                            window.open(
                                "https://vip.acessorias.com",
                                "_blank"
                            );
                        }}
                        sx={{
                            minHeight: 44,
                            px: 1.5,
                            borderRadius: "10px",
                            color: "#64748B",

                            "&:hover": {
                                backgroundColor: "#F5F7F9",
                            },
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 38,
                                color: "#64748B",
                            }}
                        >
                            <HelpOutlineOutlinedIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText
                            primary="Central de ajuda"
                            primaryTypographyProps={{
                                fontSize: 13.5,
                                fontWeight: 500,
                            }}
                        />
                    </ListItemButton>
                </ListItem>


                <ListItem disablePadding>
                    <ListItemButton
                        onClick={handleLogout}
                        sx={{
                            minHeight: 44,
                            px: 1.5,
                            borderRadius: "10px",
                            color: "#DC2626",

                            "&:hover": {
                                backgroundColor: "#FEF2F2",
                            },
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 38,
                                color: "#DC2626",
                            }}
                        >
                            <LogoutOutlinedIcon fontSize="small" />
                        </ListItemIcon>

                        <ListItemText
                            primary="Sair"
                            primaryTypographyProps={{
                                fontSize: 13.5,
                                fontWeight: 600,
                            }}
                        />
                    </ListItemButton>
                </ListItem>

            </List>

        </Box>

    </Box>
);

    return (
        <div style={{ width: "100%", backgroundColor: "#0b243d", height: "60px", display: "flex", justifyContent: "center", position: "fixed", top: "0", zIndex: 1000,}} >
            <div style={{ width: "90%", display: "flex", alignItems: "center", padding: "0 20px" }}>
                <div style={{ width: "90%", display: "flex", alignItems: "center", justifyContent: "flex-start", color: "white" }}>
                    <div onClick={toggleDrawer(true)} style={{ display: "flex", cursor: "pointer", flexDirection: "column", gap: "4px", }} className="menu-toggle" >
                        <span style={{ width: "25px", height: "3px", backgroundColor: "white" }}></span>
                        <span style={{ width: "25px", height: "3px", backgroundColor: "white" }}></span>
                        <span style={{ width: "25px", height: "3px", backgroundColor: "white" }}></span>
                    </div>
                    <div style={{ marginLeft: "16px", color: "#ffc845" }}>
                        <img src="/assets/logoClarea01.png" alt="Logo Clarea Vital" style={{ height: window.innerWidth < 600 ? "40px" : "50px", marginTop: "10px" }} />
                    </div>
                </div>
                <div style={{ color: "white", width: "fit-content", minWidth: "100px", display: window.innerWidth < 600 ? "none" : "flex" }}>
                    <Tooltip title="Ver perfil">
                        <IconButton sx={{ marginRight: "4px", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" } }} aria-label="delete" onClick={() => navigate("../Dashboard/Perfil")}>
                            <PersonIcon sx={{ color: "white", fontSize: "27px", "&:hover": { color: "gray" } }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver notificações">
                        <IconButton sx={{ marginLeft: "4px", "&:hover": { color: "rgba(255, 255, 255, 0.1)" } }} aria-label="delete" onClick={() => props.setOpenModalNotificacao(true)}>
                            <Badge badgeContent={props.notificacoes} color="error">
                                <NotificationsIcon sx={{ color: "white", fontSize: "27px", "&:hover": { color: "gray" } }} />
                            </Badge>
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
            </Drawer>
        </div>
    );
}

export default HeaderDashboard;
